export default __webpack_public_path__ + "static/O0294-19a6b3a8f436d0497fef887c69bea161.png";